/* ── TSF Theme JS ──────────────────────────────────────────────────────────
   No framework. No aggressive reinit. Everything explicit.
─────────────────────────────────────────────────────────────────────────── */

/* ── Product Gallery ─────────────────────────────────────────────────────── */
function initGalleries() {
  document.querySelectorAll('.tsf-gallery').forEach(function (gallery) {
    var pid     = gallery.dataset.productId;
    var heroImg = gallery.querySelector('.tsf-gallery__hero');
    if (!heroImg) return;

    // Thumbnail click → update hero
    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('.tsf-gallery__thumb');
      if (!thumb || thumb.hidden) return;
      setActiveThumb(gallery, heroImg, thumb);
    });

    // Hero click → lightbox
    heroImg.style.cursor = 'zoom-in';
    heroImg.addEventListener('click', function () {
      openLightbox(heroImg.src, heroImg.alt);
    });

    // Colour change → filter gallery
    document.addEventListener('colour:change', function (e) {
      if (String(e.detail.productId) !== String(pid)) return;
      filterGallery(gallery, heroImg, e.detail.colour);
    });
  });
}

function setActiveThumb(gallery, heroImg, thumb) {
  gallery.querySelectorAll('.tsf-gallery__thumb').forEach(function (t) {
    t.classList.toggle('tsf-gallery__thumb--active', t === thumb);
  });
  heroImg.src = thumb.dataset.src;
  heroImg.alt = thumb.dataset.alt || '';
}

function filterGallery(gallery, heroImg, colour) {
  var thumbs    = Array.from(gallery.querySelectorAll('.tsf-gallery__thumb'));
  // Whole words only: the prose alt text says "white background", which is
  // not a back view. (2026-10-21)
  var altSideRe = /\b(back|left|right|side|rear)\b/i;

  // 2026-10-24 (Chris): one gallery. Hide ONLY the other colours' photos. The
  // untagged (generic) lifestyle and model shots stay visible for every
  // colour, whether or not that colour has photos of its own — collection
  // tiles show the model shot, so the product page must show it too. They are
  // pushed AFTER the colour's own photos with CSS `order`
  // (.tsf-gallery__thumbs is display:flex in theme.css), because they are
  // normally first in product.media order.
  // Same rule as the initial-load rule in snippets/product-gallery.liquid —
  // the two MUST agree. It replaces the old hasOwn rule, which hid every
  // untagged photo as soon as the colour had its own.
  thumbs.forEach(function (t) {
    var c = t.dataset.colour || '';
    t.hidden = (c !== '' && c !== colour);
    t.style.order = (c === colour) ? '0' : '1';
  });

  // The photo attached to the variant itself wins; then any front view.
  var hero = thumbs.find(function (t) {
    return t.dataset.colour === colour && t.dataset.anchor === 'true';
  }) || thumbs.find(function (t) {
    if (t.dataset.colour !== colour) return false;
    return t.dataset.isBack !== 'true' && !altSideRe.test(t.dataset.alt || '');
  }) || thumbs.find(function (t) {
    return t.dataset.colour === colour && t.dataset.isBack !== 'true';
  }) || thumbs.find(function (t) {
    return t.dataset.colour === colour;
  });

  // A colour with no photo of its own: show the generic shots, not the
  // previous colour's photo. If nothing at all is left, show everything.
  if (!hero) {
    hero = thumbs.find(function (t) { return !t.hidden; });
    if (!hero && thumbs.length) {
      thumbs.forEach(function (t) { t.hidden = false; });
      hero = thumbs[0];
    }
  }

  if (hero) setActiveThumb(gallery, heroImg, hero);
}

function openLightbox(src, alt) {
  var lb = document.createElement('div');
  lb.className = 'tsf-lightbox';
  var img = document.createElement('img');
  img.src = src.replace(/width=\d+/, 'width=1600');
  img.alt = alt || '';
  lb.appendChild(img);
  lb.addEventListener('click', function () { document.body.removeChild(lb); });
  document.addEventListener('keydown', function esc(e) {
    if (e.key === 'Escape') { document.body.removeChild(lb); document.removeEventListener('keydown', esc); }
  });
  document.body.appendChild(lb);
}

/* ── Cart Drawer ─────────────────────────────────────────────────────────── */
var cartDrawer     = null;
var cartOverlay    = null;
var cartItemsEl    = null;
var cartSubtotal   = null;
var cartSubLabel   = null;
var cartTrigger    = null; // element that opened the drawer — focus returns here
var cartLastState  = null; // last /cart.js payload, so VAT flips can re-total it

function initCart() {
  cartDrawer   = document.getElementById('tsf-cart-drawer');
  cartOverlay  = document.getElementById('tsf-overlay');
  cartItemsEl  = document.getElementById('tsf-cart-items');
  cartSubtotal = document.getElementById('tsf-cart-subtotal');
  cartSubLabel = document.getElementById('tsf-cart-subtotal-label');
  if (!cartDrawer) return;

  // Open cart
  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', openCart);
  });

  // Close cart
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeCart);
  });
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // Remove items
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    removeCartItem(btn.dataset.cartRemove);
  });

  // Listen for cart updates from SQM
  document.addEventListener('tsf:cart-updated', refreshCart);

  // Escape closes the drawer
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (!cartDrawer.classList.contains('is-open')) return;
    closeCart();
  });
}

function openCart() {
  // Fall back to the header cart button when the drawer was opened
  // programmatically (e.g. after add-to-cart), so focus has somewhere to return.
  var active = document.activeElement;
  cartTrigger = (active && active !== document.body && typeof active.focus === 'function')
    ? active
    : document.querySelector('[data-cart-open]');
  refreshCart();
  cartDrawer.classList.add('is-open');
  if (cartOverlay) cartOverlay.hidden = false;
  document.body.style.overflow = 'hidden';

  // Move focus into the drawer so keyboard users land inside it
  var target = cartDrawer.querySelector('[data-cart-close]') || cartDrawer.querySelector('h2');
  if (target) {
    if (!target.hasAttribute('tabindex') && target.tagName !== 'BUTTON') target.setAttribute('tabindex', '-1');
    target.focus();
  }
}

function closeCart() {
  cartDrawer.classList.remove('is-open');
  if (cartOverlay) cartOverlay.hidden = true;
  document.body.style.overflow = '';
  if (cartTrigger && typeof cartTrigger.focus === 'function') cartTrigger.focus();
  cartTrigger = null;
}

function refreshCart() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderCartItems(cart);
      updateCartCount(cart.item_count);
    })
    .catch(function () {});
}

function renderCartItems(cart) {
  cartLastState = cart;
  if (!cartItemsEl) return;
  if (!cart.items.length) {
    cartItemsEl.innerHTML = '<p class="tsf-cart-drawer__empty">Your cart is empty</p>';
    updateCartSubtotal();
    return;
  }

  cartItemsEl.innerHTML = cart.items.map(function (item) {
    return '<div class="tsf-cart-item">' +
      (item.image ? '<img class="tsf-cart-item__img" src="' + item.image + '" alt="' + (item.title || '') + '" loading="lazy">' : '') +
      '<div class="tsf-cart-item__info">' +
        '<div class="tsf-cart-item__title">' + item.product_title + '</div>' +
        '<div class="tsf-cart-item__variant">' + item.variant_title + ' &times; ' + item.quantity + '</div>' +
        '<div class="tsf-cart-item__price" data-vat-base="' + item.line_price + '" data-vat-taxable="' + (item.taxable !== false) + '">' +
          formatMoney(item.line_price, item.taxable) +
        '</div>' +
        '<button class="tsf-cart-item__remove" data-cart-remove="' + item.key + '">Remove</button>' +
      '</div>' +
    '</div>';
  }).join('');

  updateCartSubtotal();
}

/* Subtotal = sum of each line as it is shown, using that line's own taxable
   status. Children's clothing is zero-rated, so cart.total_price * 1.2 is wrong. */
function updateCartSubtotal() {
  if (!cartSubtotal) return;
  var mode  = localStorage.getItem('tsf-vat') || 'ex';
  var items = (cartLastState && cartLastState.items) || [];
  // A basket of nothing but zero-rated children's wear has no VAT either way,
  // so labelling the subtotal "ex VAT" would contradict itself.
  var anyTaxable = items.some(function (item) { return item.taxable !== false; });

  if (cartSubLabel) {
    cartSubLabel.textContent = !anyTaxable ? 'Subtotal'
      : (mode === 'inc') ? 'Subtotal (inc VAT)' : 'Subtotal (ex VAT)';
  }

  if (!items.length) {
    cartSubtotal.textContent = '';
    return;
  }

  var total = cartLastState.items.reduce(function (sum, item) {
    var taxable = item.taxable !== false;
    return sum + ((mode === 'inc' && taxable) ? Math.round(item.line_price * 1.2) : item.line_price);
  }, 0);

  cartSubtotal.textContent = '£' + (total / 100).toFixed(2);
}

function updateCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach(function (el) {
    el.textContent = count;
    el.hidden = count === 0;
  });
}

function removeCartItem(key) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderCartItems(cart);
      updateCartCount(cart.item_count);
    });
}

function formatMoney(cents, taxable) {
  var mode = localStorage.getItem('tsf-vat') || 'ex';
  var amount = (mode === 'inc' && taxable !== false) ? cents * 1.2 : cents;
  return '£' + (amount / 100).toFixed(2);
}

/* ── Header search ───────────────────────────────────────────────────────── */
function initSearch() {
  var searchBtn = document.getElementById('tsf-search-btn');
  var searchBar = document.getElementById('tsf-search-bar');
  if (!searchBtn || !searchBar) return;
  searchBtn.addEventListener('click', function () {
    var open = searchBar.classList.toggle('is-open');
    if (open) searchBar.querySelector('input').focus();
  });
}

/* ── Mobile nav ──────────────────────────────────────────────────────────── */
function initMobileNav() {
  var menuBtn = document.getElementById('tsf-menu-btn');
  var nav     = document.getElementById('tsf-main-nav');
  if (!menuBtn || !nav) return;

  menuBtn.addEventListener('click', function () {
    var open = nav.classList.toggle('is-open');
    menuBtn.setAttribute('aria-expanded', open);
  });

  // Close mobile nav when a link is clicked
  nav.addEventListener('click', function (e) {
    if (e.target.tagName === 'A' && window.innerWidth <= 989) {
      nav.classList.remove('is-open');
      menuBtn.setAttribute('aria-expanded', 'false');
    }
  });

  // Close mobile nav when clicking outside
  document.addEventListener('click', function (e) {
    if (window.innerWidth > 989) return;
    if (!nav.contains(e.target) && !menuBtn.contains(e.target)) {
      nav.classList.remove('is-open');
      menuBtn.setAttribute('aria-expanded', 'false');
    }
  });

  // Tap mega menu trigger on mobile
  nav.addEventListener('click', function (e) {
    var trigger = e.target.closest('.tsf-megamenu-trigger');
    if (!trigger) return;
    if (window.innerWidth > 989) return;
    e.preventDefault();
    var item = trigger.closest('.tsf-has-megamenu');
    var open = item.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', open);
  });

  // Category groups are accordions inside the drawer. On desktop the CSS keeps
  // every column open, so this only ever matters at drawer widths.
  nav.addEventListener('click', function (e) {
    var title = e.target.closest('.tsf-megamenu__col-title');
    if (!title) return;
    if (window.innerWidth > 989) return;
    title.setAttribute('aria-expanded', title.getAttribute('aria-expanded') !== 'true');
  });
}

/* ── Mega menu ───────────────────────────────────────────────────────────────
   The panel is held open by the RED BAR, not by the trigger and not by a timer
   long enough to cover the journey. The bar (.tsf-header__navbar) is the
   positioned ancestor of every mega panel, so the panel is a DESCENDANT of the
   bar: anywhere the pointer can be on the way from the trigger down into the
   panel — the trigger, the gap between the wrapped rows, a row-2 item, the
   panel itself — is still inside the bar, and mouseleave on the bar does not
   fire for a move into a descendant. So "pointer is somewhere in the bar"
   is a single, exact test for "do not close yet", with no timing in it at all.

   This replaced three separate faults found on 31 Oct 2026 at a wrapped
   two-row bar width:
     1. the trigger's own mouseleave started a 350ms close the moment the
        pointer left row 1, and a deliberate (slow) journey spent longer than
        that in the gap between the rows, so the panel shut before the pointer
        ever reached it;
     2. crossing the row-2 item ("Accessories") for longer than its 150ms
        dwell threw that dropdown open, which closes the mega by design;
     3. structural: that dropdown's white panel is later in the DOM and shares
        z-index 200, so it covers the top band of the mega panel — the pointer
        arriving at the panel landed on the dropdown instead, and the mega
        panel's own mouseenter never fired.
   Bar-level hold fixes 1 and makes 3 harmless; the stillness rule in
   initDropdowns fixes 2. */
function initMegaMenus() {
  var navbar = document.querySelector('.tsf-header__navbar');
  var barCloseTimer = null;

  function holdMegaMenus() { clearTimeout(barCloseTimer); barCloseTimer = null; }
  window.tsfHoldMegaMenus = holdMegaMenus;

  if (navbar) {
    navbar.addEventListener('mouseenter', holdMegaMenus);
    navbar.addEventListener('mousemove', holdMegaMenus);
    navbar.addEventListener('mouseleave', function () {
      if (window.innerWidth <= 989) return;   // drawer owns this
      holdMegaMenus();
      barCloseTimer = setTimeout(closeAllMegaMenus, 300);
    });
  }

  /* A plain link in the bar that the pointer RESTS on — 150ms without moving —
     is a deliberate choice of that link, so an open mega panel gets out of the
     way. Stillness, not presence: merely crossing a link on the way down to
     the panel keeps firing mousemove, which re-arms the timer, so transit
     never closes anything. */
  document.querySelectorAll('.tsf-header__navbar .tsf-header__nav > a').forEach(function (link) {
    var restTimer = null;
    function arm() {
      clearTimeout(restTimer);
      if (window.innerWidth <= 989) return;
      if (!document.querySelector('.tsf-has-megamenu.is-open')) return;
      restTimer = setTimeout(closeAllMegaMenus, 150);
    }
    link.addEventListener('mouseenter', arm);
    link.addEventListener('mousemove', arm);
    link.addEventListener('mouseleave', function () { clearTimeout(restTimer); });
  });

  document.querySelectorAll('.tsf-has-megamenu').forEach(function (item) {
    var timer = null;       // close timer
    var openTimer = null;   // hover-intent open timer
    var trigger = item.querySelector('.tsf-megamenu-trigger');

    function setState(open) {
      item.classList.toggle('is-open', open);
      if (trigger) trigger.setAttribute('aria-expanded', open);
    }

    function openMenu() {
      clearTimeout(timer);
      clearTimeout(openTimer);
      if (typeof window.tsfHoldMegaMenus === 'function') window.tsfHoldMegaMenus();
      document.querySelectorAll('.tsf-has-megamenu.is-open').forEach(function (other) {
        if (other === item) return;
        other.classList.remove('is-open');
        var t = other.querySelector('.tsf-megamenu-trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      // A mega panel opening takes the bar: any open dropdown shuts.
      if (typeof window.tsfCloseAllDropdowns === 'function') window.tsfCloseAllDropdowns();
      setState(true);
    }

    // Hover intent: a short dwell before opening, so merely sweeping the
    // pointer across the trigger on the way somewhere else does not open it.
    item.addEventListener('mouseenter', function () {
      if (window.innerWidth <= 989) return;   // drawer handler owns this
      clearTimeout(timer);
      clearTimeout(openTimer);
      openTimer = setTimeout(openMenu, 100);
    });
    // Leaving the trigger cancels a PENDING open, and nothing else. It must
    // not close an open panel: the only way out of a mega panel is out of the
    // red bar, and the bar's own mouseleave handles that. See the note above.
    item.addEventListener('mouseleave', function () {
      if (window.innerWidth <= 989) return;
      clearTimeout(openTimer);
    });

    // Keyboard: tabbing into the item opens it, tabbing out of it closes it.
    // Only above the drawer breakpoint — in the drawer the panel is toggled
    // by tapping the trigger, and opening on focus would fight that.
    item.addEventListener('focusin', function () {
      if (window.innerWidth > 989) openMenu();
    });
    item.addEventListener('focusout', function (e) {
      if (window.innerWidth <= 989) return;
      if (e.relatedTarget && item.contains(e.relatedTarget)) return;
      clearTimeout(timer);
      setState(false);
    });

    // A <button> trigger has no href, so clicking it must do the opening.
    //
    // It must never do the CLOSING while the pointer is still on it. Moving the
    // mouse to the trigger already fired mouseenter and opened the panel, so a
    // plain toggle would shut the panel the instant the visitor clicked the
    // thing they were aiming at — which reads as "the menu does nothing".
    // Hovering therefore always opens; only a keyboard or touch activation,
    // where there is no hover, toggles.
    if (trigger && trigger.tagName === 'BUTTON') {
      trigger.addEventListener('click', function () {
        if (window.innerWidth <= 989) return;   // drawer handler owns this
        var hovering = false;
        try { hovering = item.matches(':hover'); } catch (e) { hovering = false; }
        if (!hovering && item.classList.contains('is-open')) { clearTimeout(timer); setState(false); }
        else { openMenu(); }
      });
    }

    // The panel itself only ever cancels: it is inside the bar, so leaving it
    // downward leaves the bar and the bar's handler does the closing.
    var menu = item.querySelector('.tsf-megamenu');
    if (menu) {
      menu.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        clearTimeout(openTimer);
        if (typeof window.tsfHoldMegaMenus === 'function') window.tsfHoldMegaMenus();
      });
    }
  });

  function closeAllMegaMenus() {
    document.querySelectorAll('.tsf-has-megamenu.is-open').forEach(function (item) {
      item.classList.remove('is-open');
      var t = item.querySelector('.tsf-megamenu-trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  // Let the dropdowns shut an open mega panel when one of them opens.
  window.tsfCloseAllMegaMenus = closeAllMegaMenus;

  // Close on click outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.tsf-has-megamenu')) closeAllMegaMenus();
  });

  // Escape closes, and puts focus back on the trigger it came from.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.tsf-has-megamenu.is-open');
    if (!open) return;
    var trigger = open.querySelector('.tsf-megamenu-trigger');
    closeAllMegaMenus();
    if (trigger && open.contains(document.activeElement)) trigger.focus();
  });
}

/* ── Regular dropdowns ───────────────────────────────────────────────────────
   A dropdown whose parent has a real page keeps its <a> and opens on hover
   alone. A parent with no page of its own is a <button class="tsf-dropdown-
   trigger">, which hover cannot reach on a touch screen, so clicking it toggles
   .is-open on the wrapper. Inside the mobile drawer the CSS keeps every
   dropdown expanded, so there is nothing for the click to do there. */
function initDropdowns() {
  function closeAllDropdowns(except) {
    document.querySelectorAll('.tsf-has-dropdown.is-open').forEach(function (d) {
      if (d === except) return;
      d.classList.remove('is-open');
      var t = d.querySelector('.tsf-dropdown-trigger');
      if (t && t.tagName === 'BUTTON') t.setAttribute('aria-expanded', 'false');
    });
  }

  document.querySelectorAll('.tsf-has-dropdown').forEach(function (item) {
    var trigger = item.querySelector('.tsf-dropdown-trigger');

    /* Hover intent, desktop only. The CSS used to open these on the first
       pixel of :hover, which is fault B: when the red bar wraps onto two rows,
       the pointer travelling from the "Shop by Category" trigger down into its
       mega panel has to pass over the row-2 trigger, and that threw the row-2
       dropdown open on top of the panel. Now the pointer has to REST on an
       item before it opens, and leaving it does not shut it instantly either,
       so crossing a trigger on the way past does nothing at all. */
    var hoverOpenTimer  = null;
    var hoverCloseTimer = null;

    function setOpen(open) {
      item.classList.toggle('is-open', open);
      if (trigger && trigger.tagName === 'BUTTON') {
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }

    function armOpen() {
      if (window.innerWidth <= 989) return;   // drawer shows the list already
      clearTimeout(hoverCloseTimer);
      clearTimeout(hoverOpenTimer);
      hoverOpenTimer = setTimeout(function () {
        closeAllDropdowns(item);
        // Opening a dropdown also shuts any open mega panel.
        if (typeof window.tsfCloseAllMegaMenus === 'function') window.tsfCloseAllMegaMenus();
        setOpen(true);
      }, 150);
    }

    item.addEventListener('mouseenter', armOpen);

    /* While a mega panel is open, the dwell becomes a STILLNESS test rather
       than a presence test: every mousemove over this item re-arms the 150ms
       timer, so it only ever fires once the pointer has actually stopped.
       That is the second fault of 31 Oct 2026 — when the bar wraps, the
       journey from the row-1 mega trigger down into the panel crosses the
       row-2 item, and a deliberate (slow) journey spends more than 150ms on
       it, which threw this dropdown open and closed the mega. Resting on the
       item still opens it; passing over it no longer does. With no mega open
       the behaviour is unchanged. */
    item.addEventListener('mousemove', function () {
      if (window.innerWidth <= 989) return;
      if (item.classList.contains('is-open')) return;
      if (!document.querySelector('.tsf-has-megamenu.is-open')) return;
      armOpen();
    });

    item.addEventListener('mouseleave', function () {
      if (window.innerWidth <= 989) return;
      clearTimeout(hoverOpenTimer);
      clearTimeout(hoverCloseTimer);
      hoverCloseTimer = setTimeout(function () { setOpen(false); }, 200);
    });

    if (!trigger || trigger.tagName !== 'BUTTON') return;

    trigger.addEventListener('click', function () {
      if (window.innerWidth <= 989) return;   // drawer shows the list already
      clearTimeout(hoverOpenTimer);
      clearTimeout(hoverCloseTimer);
      // With the panel no longer held open by CSS :hover, a plain toggle would
      // shut it the instant a mouse user clicked the trigger they had just
      // hovered open. Hovering therefore always opens; only an activation with
      // no hover behind it (keyboard, touch) can toggle shut.
      var hovering = false;
      try { hovering = item.matches(':hover'); } catch (err) { hovering = false; }
      var open = hovering ? true : !item.classList.contains('is-open');
      closeAllDropdowns(item);
      if (open && typeof window.tsfCloseAllMegaMenus === 'function') window.tsfCloseAllMegaMenus();
      setOpen(open);
    });

    // Tabbing out of the item closes it again.
    item.addEventListener('focusout', function (e) {
      if (window.innerWidth <= 989) return;
      if (e.relatedTarget && item.contains(e.relatedTarget)) return;
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.tsf-has-dropdown')) closeAllDropdowns();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.tsf-has-dropdown.is-open');
    if (!open) return;
    var trigger = open.querySelector('.tsf-dropdown-trigger');
    var inside  = open.contains(document.activeElement);
    closeAllDropdowns();
    if (trigger && inside && typeof trigger.focus === 'function') trigger.focus();
  });

  // Let the mega menus shut every dropdown when one of them opens.
  window.tsfCloseAllDropdowns = function () { closeAllDropdowns(); };
}

/* ── Colour swatches ─────────────────────────────────────────────────────── */
function initSwatches() {
  document.querySelectorAll('.tsf-swatches').forEach(function (swatches) {
    swatches.addEventListener('click', function (e) {
      var btn = e.target.closest('.tsf-swatch');
      if (!btn) return;
      swatches.querySelectorAll('.tsf-swatch').forEach(function (b) {
        b.classList.toggle('tsf-swatch--active', b === btn);
      });
      var label = swatches.querySelector('.tsf-swatches__current');
      if (label) label.textContent = btn.dataset.colour;
      document.dispatchEvent(new CustomEvent('colour:change', {
        detail: { productId: swatches.dataset.productId, colour: btn.dataset.colour }
      }));
    });
  });
}

/* ── VAT toggle ──────────────────────────────────────────────────────────── */
function initVatToggle() {
  var toggle = document.querySelector('.tsf-vat-toggle');
  if (!toggle) return;
  var mode = localStorage.getItem('tsf-vat') || 'ex';
  applyVat(mode);

  toggle.addEventListener('click', function () {
    mode = (mode === 'ex') ? 'inc' : 'ex';
    localStorage.setItem('tsf-vat', mode);
    applyVat(mode);
    document.dispatchEvent(new CustomEvent('sqm:rebuilt'));
  });

  document.addEventListener('sqm:rebuilt', function () { applyVat(mode); });
}

function applyVat(mode) {
  var toggle = document.querySelector('.tsf-vat-toggle');
  if (toggle) {
    toggle.querySelector('[data-vat-ex]').classList.toggle('tsf-vat-toggle__label--active', mode === 'ex');
    toggle.querySelector('[data-vat-inc]').classList.toggle('tsf-vat-toggle__label--active', mode === 'inc');
  }
  document.querySelectorAll('[data-vat-base]').forEach(function (el) {
    var base    = parseFloat(el.dataset.vatBase) || 0;
    var taxable = el.dataset.vatTaxable !== 'false';
    var amount  = base;
    if (mode === 'inc') {
      // data-vat-inc is a pre-computed inc-VAT figure, for totals that mix
      // taxable and zero-rated lines and so cannot just be multiplied.
      amount = (el.dataset.vatInc !== undefined) ? parseFloat(el.dataset.vatInc)
             : (taxable ? base * 1.2 : base);
    }
    el.textContent = '£' + (amount / 100).toFixed(2);
  });

  // Per-price "ex VAT" / "inc VAT" tags. Only rendered next to prices that
  // actually carry VAT (see size-quantity-selector.liquid), so a zero-rated
  // size never gets one.
  document.querySelectorAll('[data-vat-suffix]').forEach(function (el) {
    el.textContent = (mode === 'inc') ? 'inc VAT' : 'ex VAT';
  });

  document.querySelectorAll('[data-vat-note]').forEach(function (el) {
    el.textContent = (mode === 'inc') ? 'Prices shown inc VAT' : 'Prices shown ex VAT';
  });

  document.querySelectorAll('[data-vat-subtotal-label]').forEach(function (el) {
    el.textContent = (mode === 'inc') ? 'Subtotal (inc VAT)' : 'Subtotal (ex VAT)';
  });

  updateCartSubtotal();
}

/* ── Cart page: quantities save themselves ───────────────────────────────────
   Changing a quantity on the cart page submits the cart form after a short
   pause, using the "update" button so Shopify updates the cart and returns to
   /cart. The page reload is what keeps the summary figures, the header count
   and the drawer in step, so there is nothing to recalculate here and no way
   to loop (a fresh page fires no input event). The checkout button is never
   the submitter. With JavaScript off, "Update cart" still does the same job. */
function initCartPageAutoUpdate() {
  var form = document.getElementById('tsf-cart-form');
  if (!form) return;
  var updateBtn = form.querySelector('[data-cart-update]');
  var timer = null;
  var submitting = false;

  form.addEventListener('input', function (e) {
    if (!e.target || e.target.name !== 'updates[]') return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (submitting) return;
      submitting = true;
      form.classList.add('is-updating');
      if (updateBtn && typeof form.requestSubmit === 'function') {
        form.requestSubmit(updateBtn);
      } else {
        // Fallback: a plain POST of updates[] still updates the cart. It is
        // only reached if requestSubmit is missing, and never sends "checkout".
        form.submit();
      }
    }, 700);
  });

  // Enter inside a quantity box should update, not check out.
  form.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (!e.target || e.target.name !== 'updates[]') return;
    e.preventDefault();
    clearTimeout(timer);
    if (submitting) return;
    submitting = true;
    form.classList.add('is-updating');
    if (updateBtn && typeof form.requestSubmit === 'function') form.requestSubmit(updateBtn);
    else form.submit();
  });
}

/* ── Back to top ─────────────────────────────────────────────────────────── */
function initBackToTop() {
  var btn = document.getElementById('tsf-back-to-top');
  if (!btn) return;
  window.addEventListener('scroll', function () {
    btn.hidden = window.scrollY < 400;
  }, { passive: true });
  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

/* ── Init ────────────────────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function () {
  initGalleries();
  initCart();
  initSearch();
  initMobileNav();
  initMegaMenus();
  initDropdowns();
  initSwatches();
  initVatToggle();
  initCartPageAutoUpdate();
  initBackToTop();
  refreshCart();
});
